import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Quote } from "lucide-react";

export const TestimonialsSection = () => {
  const [quotes, setQuotes] = useState([]);
  useEffect(() => {
    api.get("/public/testimonials").then((r) => setQuotes(r.data || [])).catch(() => {});
  }, []);
  if (!quotes.length) return null;
  return (
    <section data-testid="testimonials-section" className="border-y border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <h2 className="text-center font-heading text-3xl font-black text-slate-900 sm:text-4xl">What contractors say</h2>
        <p className="mt-2 text-center text-sm text-slate-500">Verified quotes from real Fast Estimate users, shared with permission.</p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {quotes.map((q, i) => (
            <figure key={`${q.name}-${i}`} data-testid={`testimonial-${i}`} className="rounded-2xl border-2 border-slate-200 bg-white p-6">
              <Quote className="h-6 w-6 text-indigo-400" />
              <blockquote className="mt-3 text-slate-700">“{q.quote}”</blockquote>
              <figcaption className="mt-4 text-sm font-bold text-slate-900">
                {q.name}{q.company ? <span className="font-normal text-slate-500"> — {q.company}</span> : null}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
